export const isPopUpWindow = (): boolean => {
  try {
    return !!window.opener;
  } catch {
    return false;
  }
};

export default isPopUpWindow;
